import httpService from "@/utils/services/http_service";

export default {
    /**
     * @author: lafitewu
     * date: 2020-04-13
     *  管理员列表
     */

    //  公告管理列表
    async noticeList(data={}) {
      return httpService.post(
        '/api.php?do=admin_notice_list',
        data
      )
    },

    //  公告管理新增
    async noticeAdd(data={}) {
      return httpService.post(
        '/api.php?do=admin_notice_add',
        data
      )
    },

    //  用户组列表
    async userList(data={}) {
      return httpService.post(
        '/api.php?do=admin_client_group_list',
        data
      )
    },

    //  编辑提交
    async editInit(data={}) {
      return httpService.post(
        '/api.php?do=admin_notice_edit',
        data
      )
    },

    //  编辑详情
    async editInfo(data={}) {
      return httpService.post(
        '/api.php?do=admin_notice_info',
        data
      )
    },

    //  删除
    async deleteFn(data={}) {
      return httpService.post(
        '/api.php?do=admin_notice_delete',
        data
      )
    },
    
    // 1.6新增 by-lafitewu 2020-11-26
    async fieldConfigList(data={}) {
      return httpService.post(
        '/api.php?do=admin_syndication_field_config_list',
        data
      )
    },

    async syndicationConfigFieldList(data={}) {
      return httpService.post(
        '/api.php?do=admin_syndication_config_field_list',
        data
      )
    },

    async syndicationConfigFieldAdd(data={}) {
      return httpService.post(
        '/api.php?do=admin_syndication_field_config_create',
        data
      )
    },

    async syndicationConfigFieldEdit(data={}) {
      return httpService.post(
        '/api.php?do=admin_syndication_field_config_edit',
        data
      )
    }
}